/**
 * COOKIE-BYTE.JS
 */

import { CookieConsent, CookieCovers, CookieModal } from "../../../vendor/ddm-studio/cookie-byte";
import InitMapsLibrary from "../customer/maps-library";

export default function InitCookieByte() {
	window.CookieConsent = new CookieConsent({
		autorun: false,
	});
	window.CookieModal = new CookieModal(window.CookieConsent);
	window.CookieCovers = new CookieCovers(window.CookieConsent);

	window.CookieConsent.registerCallback("thirdparty", function () {
		const iframeWrappers = document.querySelectorAll(".iframe-wrapper");

		iframeWrappers.forEach((iframeWrapper) => {
			if (iframeWrapper !== undefined) {
				var scriptTag = iframeWrapper.querySelector('script[type="text/htmlsnippet"]');
				if (scriptTag === null) return;

				var htmlNode = document.createElement("div");
				htmlNode.innerHTML = scriptTag.text.trim();
				iframeWrapper.prepend(htmlNode.firstChild);
			}
		});
	});

	window.CookieConsent.registerCallback("thirdparty", InitMapsLibrary);

	window.CookieConsent.registerCallback("thirdparty", () => {
		if (document.querySelectorAll('.calendly-inline-widget').length === 0) return;

		const calendlyScript = document.createElement('script');
		calendlyScript.type = "text/javascript";
		calendlyScript.src = "https://assets.calendly.com/assets/external/widget.js";
		calendlyScript.async = true;
		document.body.appendChild(calendlyScript);
	});

	window.CookieConsent.runCallbacks();
}
